<template>
    <div class="page">
        <div class="doc-page">
            <div class="left" ref="left">
                <div :class="['directory-list', isScroll? 'is-fiexd': null]" :style="{'width': fiexdWidth}">
                    <div class="theme">Catalog</div>
                    <div class="items">
                        <catalog v-if="directory.length" :arr="directory" :index="currentId" :root="this"></catalog>
                    </div>
                </div>
            </div>
            <div class="doc" v-loading="isLoad">
                <div class="title"><p>{{ title }}<i class="el-icon-download t-btn" @click="getMaterialById"></i></p></div>
                <div class="paper">
                     <div id="iframeContainer"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getMaterialHtml, getMaterialById} from "@/api/documentation"
import axios from "axios"
import catalog from './htmldocCatalog'
export default {
    name: 'WebsiteVueHtmldoc',

    components: {
        catalog
    },

    data() {
        return {
            materialId: null,
            directory: [],
            directoryList: {},
            title: '',
            src: '',
            doc: null,
            selectedIndex: 0,
            isScroll: false,
            activeTIndex: '',
            isLoad: false,
            pages: [],
            currentId: ''
        };
    },

    computed: {
        fiexdWidth() {
            if (this.isScroll) {
                return this.$refs.left.clientWidth + 'px'
            } else {
                return '100%'
            }
        }
    },

    mounted() {
        this.materialId = this.$route.params.id
        if (this.materialId) {
            this.getData()
        }
        window.addEventListener('scroll', () => this.contentScroll(), false);
    },

    methods: {
        async getMaterialById() {
           if (!this.materialId) {
            return false;
           }
           const {data: {data, isSuccess}} = await getMaterialById({
                id: this.materialId
           })
           if (isSuccess) {
            // console.log(data)
            window.open(`${this.domainUrl + data.viewUrl}`)
           }
        },
        async activeTreeIndex(value) {
            this.isLoad = true;
            this.activeTIndex = value.id;
            await this.getPaper(value.url)
        },
        contentScroll(e) {
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            this.isScroll = scrollTop >= 100;
        },
        async getData() {
            const {data: {data, isSuccess}} = await getMaterialHtml({
                materialId: this.materialId
            })
            if (isSuccess) {
                this.title = data[0].title
                await this.downloadxml(data[0].src)
                this.activeTreeIndex(this.directory[0])
            }
        },
        async downloadxml(src) {
            let src1 = src.replace('https://resources.holowits.com.sg/', '/resource/');
            let rsp = await axios.get(src1);
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(rsp.data, 'text/xml');
            const root = xmlDoc.documentElement;
            let pages = []
            this.collectTopics(root, pages)
            this.pages = pages
            console.log("pages", this.pages)
            let directory = []
            this.buildMenuHTML(root, directory)
            this.directory = directory

        },
        buildMenuHTML(parentNode, directoryNode) {
            // console.log([parentNode.childNodes])
            const children = Array.from(parentNode.childNodes).filter(n => 
                n.nodeType === 1 && n.localName && n.localName.toLowerCase() === 'topic'
            );
            for (let topic of children) {
                let obj = {
                    id: topic.getAttribute('id'),
                    label: topic.getAttribute('txt'),
                    url: topic.getAttribute('url')
                }
                directoryNode.push(obj)
                const subTopics = Array.from(topic.childNodes).filter(n => 
                    n.nodeType === 1 && n.localName && n.localName.toLowerCase() === 'topic'
                );
                
                if (subTopics.length > 0) {
                    obj.children = []
                    this.buildMenuHTML(topic, obj.children);
                }
            }
        },
        collectTopics(node, result) {
            const children = Array.from(node.childNodes).filter(n => 
                n.nodeType === 1 && n.localName && n.localName.toLowerCase() === 'topic'
            );
            for (let topic of children) {
                const id = topic.getAttribute('id');
                const title = topic.getAttribute('txt') || '未命名';
                const rawUrl = topic.getAttribute('url') || '#';
                if (id) {  // 只收集有 id 的页面（通常都有）
                    result.push({
                        id: id,
                        rawUrl: rawUrl,
                        title: title,
                        normalizedUrl: this.normalizeUrl(rawUrl)
                    });
                } else {
                    console.warn('Topic 缺少 id 属性:', title);
                }
                this.collectTopics(topic, result);
            }
        },
        normalizeUrl(url) {
            if (!url) return '';
            try {
                // 将 %20 等编码转换为实际字符（空格 -> 空格）
                url = decodeURIComponent(url);
            } catch(e) {
                // 如果解码失败，保持原样
            }
            // 去掉查询参数和锚点
            let clean = url.split('?')[0].split('#')[0];
            // 提取文件名（最后一个斜杠后的部分）
            let parts = clean.split('/');
            let filename = parts[parts.length - 1];
            // 可选：统一转为小写（如果文件系统大小写不敏感，可取消注释）
            // filename = filename.toLowerCase();
            return filename;
        },

        async getPaper(src) {
            // this.selectedIndex = index
            let src1 = src.replace('https://resources.holowits.com.sg/', '/resource/');
            // rsp = await axios.get(src1);
            const iframeContainer = document.getElementById('iframeContainer');
            let iframe = document.createElement('iframe');
            iframe.style.visibility = 'hidden';
            iframe.style.width = '100%';
            iframe.style.minHeight = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';
            // iframe.sandbox = '';
            iframeContainer.innerHTML = '';
            iframeContainer.appendChild(iframe);
            iframe.onload = () => {
                console.log('iframe 加载完成');
                try {
                    let currentSrc = iframe.src;
                    if (iframe.contentWindow && iframe.contentWindow.location) {
                        currentSrc = iframe.contentWindow.location.href;

                        const iframeDoc = iframe.contentWindow.document;
                        const newHeight = iframeDoc.body.scrollHeight;
                        iframe.style.height = (newHeight + 100) + 'px';
                    }
                    iframe.style.visibility = 'visible';
                    if (!currentSrc || currentSrc === 'about:blank') return;
                    const idx = this.findIndexByUrl(currentSrc);
                    if (idx !== -1) {
                        const newId = this.pages[idx].id;
                        if (newId !== this.currentId) {
                            this.currentId = newId;
                            // this.updateButtonsAndInfo();
                            // this.highlightActiveLink(currentId);
                            console.log(`同步: 切换到 ${this.pages[idx].title} (${this.currentId})`);
                        }
                    } else {
                        console.warn('iframe 内页面不在导航列表中:', currentSrc);
                    }
                } catch(e) {
                    console.warn('无法获取 iframe location (可能跨域):', e);
                    // 降级：仅使用 iframe.src
                }
                this.isLoad = false;
            };
            iframe.src = src1;
        },
        findIndexByUrl(url) {
            console.log('url:', url)
            const norm = this.normalizeUrl(url);
            console.log('norm:', norm)
            return this.pages.findIndex(p => p.rawUrl === url || p.normalizedUrl === norm);
        },
        updateButtonsAndInfo() {
            const idx = this.findIndexById(this.currentId);
            if (idx === -1) {
                prevBtn.disabled = true;
                nextBtn.disabled = true;
                pageInfo.textContent = '';
                return;
            }
            prevBtn.disabled = (idx === 0);
            nextBtn.disabled = (idx === this.pages.length - 1);
            pageInfo.textContent = `${idx+1} / ${this.pages.length}`;
        },
        findIndexById(id) {
            return this.pages.findIndex(p => p.id === id);
        },
        // highlightActiveLink(activeId) {
        //     const allLinks = document.querySelectorAll('#nav a');
        //     allLinks.forEach(link => {
        //         link.style.backgroundColor = '';
        //         link.style.fontWeight = 'normal';
        //         if (link.getAttribute('data-id') === activeId) {
        //             link.style.backgroundColor = '#e0e7ff';
        //             link.style.fontWeight = '500';
        //         }
        //     });
        // }
    },
};
</script>

<style lang="scss" scoped>

.page {
    min-height: 100vh;
    background-color: #F9F9F9;
    width: 100%;
    margin: auto;
}

.title {
    font-size: 40px;
    margin-bottom: 15px;
    .t-btn {
        font-size: 32px;
        cursor: pointer;
        margin-left: 40px;
        padding: 5px;
        // color: #d2333c;
        color: #ffffff;
        border: 2px solid #d2333c;
        background-color: #d2333c;
        border-radius: 12px;
    }
}
.theme {
    font-size: 22px;
    font-weight: 600;
}
.left {
    width: 20%;
    // height: 100%;
}
.directory-list {
    background-color: #ffffff;
    padding: 10px;
    width: 100%;
    
    .items {
        max-height: 600px;
        overflow-y: auto;
        &::-webkit-scrollbar {
            width: 2px;
            background-color: #ffffff;
        }
        &::-webkit-scrollbar-thumb {
            background-color: #d2333b83;
            
        }
        .item {
            font-size: 16px;
            height: 45px;
            line-height: 45px;
            border-bottom: 1px solid #ccc;
            &:hover {
                cursor: pointer;
                color: #d2333c;
            }
        }
    }
    
    .active {
        cursor: pointer;
        color: #d2333c;
    }
}
.doc {
    background-color: #ffffff;
    width: calc(100% - 20% - 20px);
    // float: left;
    margin-left: calc(20px);
    padding: 10px;
}
.doc-page {
    // overflow: hidden;
    width: 1600px;
    min-height: 100vh;
    margin: auto;
    padding-top: 20px;
    padding-bottom: 20px;
    display: flex;
    justify-content: flex-start;
}
.is-fiexd {
    position: fixed;
    top: 85px;
}
.paper {
    margin-top: 20px;
}
iframe {
    width: 100%;
    min-height: 2000px;
}
</style>